"use client";

import {
	type PropsWithChildren,
	type RefObject,
	createContext,
	useCallback,
	useContext,
	useRef,
} from "react";

const ScrollToTopContext =
	createContext<RefObject<HTMLDivElement | null> | null>(null);

export function ScrollToTopProvider({ children }: PropsWithChildren) {
	const elAtTheTopRef = useRef<HTMLDivElement>(null);
	return (
		<ScrollToTopContext.Provider value={elAtTheTopRef}>
			{children}
		</ScrollToTopContext.Provider>
	);
}

export function useScrollToTop() {
	const scrollToTopRef = useContext(ScrollToTopContext);
	return {
		scrollToTopRef,
		scrollToTop: useCallback(() => {
			scrollToTopRef?.current?.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		}, [scrollToTopRef]),
	};
}
